import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"height":"44px"} }
const _hoisted_2 = { style: {"margin-top":"8px","position":"absolute"} }
const _hoisted_3 = { style: {"position":"absolute","top":"70px","right":"8px"} }
const _hoisted_4 = {
  key: 0,
  style: {"margin-left":"auto","margin-right":"auto","padding":"8px","width":"100%","display":"flex","flex-direction":"column","height":"calc(100% - 56px)"}
}
const _hoisted_5 = {
  style: {"display":"flex","flex-direction":"row","overflow-x":"auto"},
  class: "hidden-scrollbar",
  id: "roundLabels"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  style: {"display":"flex","flex-direction":"row","overflow-y":"auto","overflow-x":"visible","flex":"1"},
  id: "bracketContent"
}
const _hoisted_9 = { key: 0 }

import { onMounted, ref, watchEffect } from 'vue';
import _ from 'lodash';
import Match from './Match.vue';
import { bracketService } from '@/services/bracket.service';
import { Vote } from '../interfaces/votes';


export default /*#__PURE__*/_defineComponent({
  __name: 'Bracket',
  props: ['bracket'],
  setup(__props) {

const props = __props;

let _second: any = 1000;
let _minute: any = _second * 60;
let _hour: any = _minute * 60;
let _day: any = _hour * 24;

let hours: any = ref("00");
let minutes: any = ref("00");
let seconds: any = ref("00");
let hideFinished: any = ref(true);
let roundOffset: any = ref(0);

function getRoundTitle(roundIndex: number) {
    if (roundIndex === filteredBracket.value.rounds.length - 1) {
        return '(Finals)';
    } else if (roundIndex === filteredBracket.value.rounds.length - 2) {
        return '(Semi Finals)'
    } else if (roundIndex === filteredBracket.value.rounds.length - 3) {
        return '(Top 8)'
    }
    return '';
}




function getRoundClasses(i: any) {
    let cls: Record<string, boolean> = {};
    cls['round' + (i + 1)] = true;
    cls['stop'] = i + 1 >= filteredBracket.value.rounds.length;
    return cls;
}

function showTimeRemaining() {
    try {
        if (!_.isNumber(props.bracket.currentVoteRound) || props.bracket.currentVoteRound === -1) {
            return;
        }
        let round = props.bracket.rounds[props.bracket.currentVoteRound];


        let distance = round.end - Date.now();

        if (distance >= 0) {
            // clearInterval(timer);
            hours.value = Math.floor((distance % _day) / _hour);
            minutes.value = Math.floor((distance % _hour) / _minute);
            seconds.value = Math.floor((distance % _minute) / _second);

            if (hours.value < 10) hours.value = "0" + hours.value;
            if (minutes.value < 10) minutes.value = "0" + minutes.value;
            if (seconds.value < 10) seconds.value = "0" + seconds.value;
        }
    } catch (e) {
        hours.value = "00";
        minutes.value = "00";
        seconds.value = "00";
    }

}

showTimeRemaining();
setInterval(function () {
    showTimeRemaining();
}, 1000);


let filteredBracket: any = ref(null);

function filterBracket() {
    let bracketClone = _.cloneDeep(props.bracket);
    if (props.bracket.currentVoteRound > 0 && hideFinished.value) {
        bracketClone.rounds = props.bracket.rounds.slice(props.bracket.currentVoteRound);
        bracketClone.currentVoteRound = 0;
        roundOffset.value = props.bracket.currentVoteRound;
    } else {
        roundOffset.value = 0;
    }

    filteredBracket.value = bracketClone;
}

watchEffect(() => {
    filterBracket();
});

function vote(v: Vote) {
    bracketService.vote(v);
}

onMounted(async () => {
    console.log('started');
    const div1 = document.getElementById('roundLabels');
    const div2 = document.getElementById('bracketContent');

    // Add a window scroll event listener
    div2?.addEventListener('scroll', function() {
        console.log(div1?.scrollLeft, div2?.scrollLeft);
        // Synchronize the scroll positions of div1 and div2
        if (div1 && div2 && div1.scrollLeft !== div2.scrollLeft) {
            div1.scrollTo({left: div2?.scrollLeft});
        }
    }, false);
});


return (_ctx: any,_cache: any) => {
  const _component_v_switch = _resolveComponent("v-switch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(props.bracket.name), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_switch, {
          color: "purple",
          modelValue: _unref(hideFinished),
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => (_isRef(hideFinished) ? (hideFinished).value = $event : hideFinished = $event)),
            filterBracket
          ],
          label: "Hide Finished Rounds",
          "hide-details": ""
        }, null, 8, ["modelValue"])
      ])
    ]),
    (_unref(filteredBracket))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredBracket).rounds, (round, $roundIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: round.id
              }, [
                _createElementVNode("div", {
                  class: "round-header",
                  style: _normalizeStyle({ 'margin-left': $roundIndex ? '40px' : '' })
                }, [
                  _createTextVNode(" Round " + _toDisplayString(1 + $roundIndex + _unref(roundOffset)) + " " + _toDisplayString(getRoundTitle($roundIndex)) + " ", 1),
                  ($roundIndex === _unref(filteredBracket).currentVoteRound)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, " - " + _toDisplayString(round?.participants || 0) + " voters ", 1))
                    : _createCommentVNode("", true),
                  ($roundIndex === _unref(filteredBracket).currentVoteRound)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, " - " + _toDisplayString(_unref(hours)) + ": " + _toDisplayString(_unref(minutes)) + ": " + _toDisplayString(_unref(seconds)), 1))
                    : _createCommentVNode("", true)
                ], 4)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredBracket).rounds, (round, $roundIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: round.id
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(round.matches, (match, $index) => {
                  return (_openBlock(), _createBlock(Match, {
                    onVote: vote,
                    match: match,
                    round: $roundIndex,
                    index: $index,
                    currenteVoteRound: _unref(filteredBracket).currentVoteRound,
                    class: _normalizeClass(getRoundClasses($roundIndex)),
                    voting: $roundIndex === _unref(filteredBracket).currentVoteRound,
                    "actual-round": props.bracket.currentVoteRound,
                    key: match.id
                  }, null, 8, ["match", "round", "index", "currenteVoteRound", "class", "voting", "actual-round"]))
                }), 128)),
                ($roundIndex === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, " "))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})